import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faChartSimple,
  faHandshake,
  faHeart,
  faLightbulb,
  faStar,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { ensureThemeJsonArray, getStoredUser, themeCssVars } from "../../functions/themeAssets";
import "../common/player.css";

// each rule card cycles through these icons and the theme's answer colours
const RULE_ICONS = [faLightbulb, faHeart, faChartSimple, faUsers, faHandshake, faStar];
const RULE_TONES = ["var(--iq-maybe)", "var(--iq-yes)", "var(--iq-no)", "var(--iq-box)"];

export default function Rules() {
  const navigate = useNavigate();
  const { status, data: themeData } = useSelector((state) => state.theme);
  const user = getStoredUser();

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    } else if (Number(user.gameover ?? 0) > 0) {
      Swal.fire({
        title: "Already Played",
        text: "You have already played this game.",
        icon: "info",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = user.backButtonRedirect || process.env.REACT_APP_BASE_URL || "/";
      });
    }
  }, [user, navigate]);

  if (!user) return null;

  if (!themeData || status === "loading") {
    return (
      <div className="iq-loader">
        <div className="iq-loader-spinner" />
      </div>
    );
  }

  const rules = ensureThemeJsonArray(themeData.rules);

  return (
    <div className="iq-rules" style={themeCssVars(themeData)}>
      <h1 className="iq-rules-title">How to Play</h1>
      <ul className="iq-rule-list">
        {rules.map((rule, i) => (
          <li key={i} className="iq-rule-card" style={{ "--iq-tone": RULE_TONES[i % RULE_TONES.length] }}>
            <span className="iq-rule-icon">
              <FontAwesomeIcon icon={RULE_ICONS[i % RULE_ICONS.length]} />
            </span>
            <span className="iq-rule-text">{rule}</span>
          </li>
        ))}
      </ul>
      <Link to="/game" className="iq-btn iq-next">
        Next <FontAwesomeIcon icon={faArrowRight} />
      </Link>
    </div>
  );
}
